import {
  Box,
  Button,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { MainLayoutContainer } from "components/Layout";
import {
  useGetNotificationsForUserQuery,
  useMarkAllNotificationsReadMutation,
} from "graphql/__generated__/hooks";
import { useAuthUser } from "hooks/useAuthUser";

export const InAppNotifications = () => {
  const { user } = useAuthUser();
  const { data, loading, refetch } = useGetNotificationsForUserQuery({
    variables: { userId: user?.user_id || "" },
    skip: !user?.user_id,
  });
  const [markAllRead, { loading: marking }] =
    useMarkAllNotificationsReadMutation();

  const items = data?.notification ?? [];
  const unread = items.filter((n) => !n.already_viewed).length;

  const handleMarkAllRead = async () => {
    if (!user?.user_id) return;
    await markAllRead({ variables: { userId: user.user_id } });
    await refetch();
  };

  return (
    <MainLayoutContainer title="Notifications" loading={loading}>
      {unread > 0 && (
        <Box sx={{ mb: 2 }}>
          <Button
            variant="outlined"
            size="small"
            onClick={handleMarkAllRead}
            disabled={marking}
          >
            Mark all as read
          </Button>
        </Box>
      )}
      {items.length === 0 && !loading ? (
        <Typography color="text.secondary">No notifications yet.</Typography>
      ) : (
        <List>
          {items.map((n) => (
            <ListItem key={n.notification_id} divider alignItems="flex-start">
              <ListItemText
                primary={
                  <Typography
                    component="span"
                    fontWeight={n.already_viewed ? 400 : 600}
                  >
                    {n.text}
                  </Typography>
                }
                secondary={
                  n.link ? (
                    <Typography
                      component="a"
                      href={n.link}
                      variant="body2"
                      sx={{ wordBreak: "break-all" }}
                    >
                      {n.link}
                    </Typography>
                  ) : null
                }
              />
            </ListItem>
          ))}
        </List>
      )}
    </MainLayoutContainer>
  );
};
